import Dialog from "@/components/ui/Dialog/Dialog";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { useMutation } from "@tanstack/react-query";
import useUiContext from "@/custolink-hooks/useUiContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";
import { FrontendAssetScanApi } from "@/custolink-transpiled_by_server/bc.assets.api_methods";

export default function NudgeToDefaultViewDialog(p: {
  assetViewDetails: AssetViewDetails;
  show: boolean;
  onDenyNudge: () => void;
}) {
  const [query, setQuery] = useState("");
  const uic = useUiContext();
  const { t } = useTranslation();
  const searchQuery = useMutation({
    mutationFn: () =>
      FrontendAssetScanApi.assetLookup(
        uic._orgId,
        query.trim(),
      ),
  });

  useEffect(() => {
    if (searchQuery?.data?.defaultViewResult != null) {
      // Navigate to the asset landing page with the serial number
      window.location.href = `/asset/${searchQuery.data.defaultViewResult.serialnumber}`;
    }
  }, [searchQuery?.data]);

  return (
    <Dialog
      isOpen={p.show}
      onClose={p.onDenyNudge}
      onRequestClose={p.onDenyNudge}
    >
      <h5 className="mb-4">{t('nudge.unlockMore')}</h5>
      <div className="space-y-4">
        <p>{t('nudge.getDetailsAndSupport')}</p>

        <div className={"justify-center flex"}>
          <Input
            type={"text"}
            placeholder={t('nudge.inputSerial')}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
        <div className={"justify-center flex"}>
          <Button
            variant={"solid"}
            loading={searchQuery.isPending}
            onClick={() => {
              searchQuery.mutateAsync();
            }}
          >
            {t("nudge.unlockWithSerial")}
          </Button>
        </div>

        <div>
          {searchQuery?.data != undefined && (
            <>
              {searchQuery?.data.defaultViewResult == null && (
                <>{t("nudge.search.noResults")}</>
              )}
            </>
          )}
        </div>

        <p className={"justify-center flex"}>
          <Button variant={"default"} onClick={() => p.onDenyNudge()}>
            {
              t('nudge.continueWithoutSerial')
            }
          </Button>
        </p>
      </div>
    </Dialog>
  );
}
